import CryptoJS from 'crypto-js';

var key = CryptoJS.enc.Utf8.parse('QtB5Ts6yG3nZ5MV@');//秘钥
var iv = CryptoJS.enc.Utf8.parse("1234567891234567"); //向量

// Encrypt
export function encryptData() {
    var date = new Date();
    var data = 'zS7xswpyy5GTJvaj3Ho3Kw==' + 't|t' + date.getTime(); //加密数据
    var encrypt = CryptoJS.AES.encrypt(data, key, {
        iv: iv,
    })
    var data2 = encrypt.toString();//加密后的数据
    return encodeURIComponent(data2);
}
